import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["setVisible", "isFiltersEnabled", "isFiltersVisible", "onClick"];
import React from 'react';
import { connect } from 'react-redux';
import { IconSearchOutline } from '@carnica/graphics';
import { Button } from "../../../../shared/ui";
import { selectIsFiltersEnabled, selectIsFiltersVisible, setIsFiltersVisible } from "../../../../entities/filters/model";
var ShowFiltersRender = function ShowFiltersRender(props) {
  var setVisible = props.setVisible,
    isFiltersEnabled = props.isFiltersEnabled,
    isFiltersVisible = props.isFiltersVisible,
    onClick = props.onClick,
    otherProps = _objectWithoutProperties(props, _excluded);
  var handleClick = function handleClick(e) {
    onClick === null || onClick === void 0 || onClick(e);
    setVisible(!isFiltersVisible);
  };
  if (!isFiltersEnabled) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Button, _extends({}, otherProps, {
    "aria-label": "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u0430\u043D\u0435\u043B\u044C \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0438",
    form: "round",
    iconLeft: IconSearchOutline,
    onClick: handleClick,
    onlyIcon: true,
    size: "m",
    view: "tertiary-invert",
    "data-t-id": "ui-ShowFilters"
  }));
};
var mapStateToProps = function mapStateToProps(store) {
  return {
    isFiltersEnabled: selectIsFiltersEnabled(store),
    isFiltersVisible: selectIsFiltersVisible(store)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setVisible: function setVisible(flag) {
      return dispatch(setIsFiltersVisible(flag));
    }
  };
};
export var ShowFilters = connect(mapStateToProps, mapDispatchToProps)(ShowFiltersRender);